import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { ErrorsService } from "../services/errors.service";

@Injectable()
export class ErrorsHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: Error | HttpErrorResponse) {
    const errorsService = this.injector.get(ErrorsService);

    if (error instanceof HttpErrorResponse) {
      if (!navigator.onLine) {
        // No Internet connection
      }
    }

    errorsService.log(error).subscribe((errorWithContextInfo: any) => {
      errorsService.showError(errorWithContextInfo);
    });
  }
}
